// The econtract is not created yet.
export const fundEcontractStatusTypeNew = 1000;

// The econtract is created, but not signed by customer yet.
export const fundEcontractStatusTypePending = 1001;

// Status for fund signed the e-contract. When the status is approved, the econtract is completed.
export const fundEcontractStatusTypeApproved = 1002;

// Status for customer signed the e-contract.
// This will be done first by customer, then the fund will sign the e-contract after that.
export const fundEcontractStatusTypeSigned = 1003;

export const fundEContractStatusColors = {
  [fundEcontractStatusTypeNew]: '#6b7280',
  [fundEcontractStatusTypePending]: '#f59e0b',
  [fundEcontractStatusTypeSigned]: '#3b82f6',
  [fundEcontractStatusTypeApproved]: '#008000',
};
